import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query FlexiPointsExpiryList($walletId: ID!, $currency: String!, $fromDate: String!, $beforeDate: String!) {
    flexiPointsExpiryList(walletId: $walletId, currency: $currency, fromDate: $fromDate, beforeDate: $beforeDate) {
      total
      breakdown {
        amount
        currency
        expiresAt
      }
    }
  }
`

export const flexiPointsExpiryListKey = getQueryNames(query)[0]

export default query
